import script from "./WptMainFunctions.vue?vue&type=script&setup=true&lang=js"
export * from "./WptMainFunctions.vue?vue&type=script&setup=true&lang=js"

import "./WptMainFunctions.vue?vue&type=style&index=0&id=d49be480&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d49be480"]])

export default __exports__